const icons = {
  profile: '<circle cx="12" cy="7" r="4"/><path d="M4 22v-2a8 8 0 0 1 16 0v2H4Z"/>',
  skin: '<path d="m8 3-5 3 3 5 2-1v11h8V10l2 1 3-5-5-3a4 4 0 0 1-8 0Z"/>',
  ranking: '<path d="m3 6 4 4 5-7 5 7 4-4-3 12H6L3 6Zm4 14h10v2H7z"/>',
  gacha: '<path d="M7 3h10v3H7zM6 7h12v9H6zM8 17h8l2 5H6z"/><circle cx="12" cy="11.5" r="2.5" fill="var(--menu-icon-inset, #11180f)"/>',
  settings: '<path d="m10 2-1 3-2 1-3-1-2 4 2 2v2l-2 2 2 4 3-1 2 1 1 3h4l1-3 2-1 3 1 2-4-2-2v-2l2-2-2-4-3 1-2-1-1-3Z"/><circle cx="12" cy="12" r="3.5" fill="var(--menu-icon-inset, #11180f)"/>',
  action: '<path d="M13 3h8v8h-2V6.4l-9.3 9.3-1.4-1.4L17.6 5H13V3Z"/><path d="M3 5h7v2H5v12h12v-5h2v7H3V5Z"/>',
  cards: '<rect x="3" y="5" width="13" height="17" rx="1" fill="none" stroke="currentColor" stroke-width="1.6"/><rect x="8" y="2" width="13" height="17" rx="1" fill="var(--menu-icon-inset, #11180f)" stroke="currentColor" stroke-width="1.6"/><circle cx="14.5" cy="10.5" r="3.5"/>',
} as const;

function icon(name: keyof typeof icons): string {
  return `<svg class="side-menu__icon side-menu__icon--${name}" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false">${icons[name]}</svg>`;
}

export function sideMenuMarkup(): string {
  return `<nav class="side-menu" aria-label="メインメニュー">
    ${([
      ['profile', 'プロフィール'], ['skin', 'スキン'], ['ranking', 'ランキング'], ['gacha', 'ガチャ'],
    ] as const).map(([id, label]) => `<button id="${id}-button" class="side-menu__button" type="button" aria-haspopup="dialog" aria-expanded="false" aria-controls="${id === 'profile' ? 'profile-dialog' : id === 'ranking' ? 'ranking-dialog' : 'economy-dialog'}" aria-label="${label}">
      ${icon(id)}<span class="side-menu__label">${label}</span>
    </button>`).join('')}
    <button id="settings-button" class="side-menu__button" type="button" aria-haspopup="dialog" aria-controls="settings-screen" aria-expanded="false">
      ${icon('settings')}<span class="side-menu__label">設定</span>
    </button>
    <a id="action-link" class="side-menu__button" href="https://reversi-destiny.pages.dev/" target="_blank" rel="noopener noreferrer external" aria-label="2Dアクション（別タブで開く）" title="別タブで開く">
      ${icon('action')}<span class="side-menu__label side-menu__label--wrap"><span>2D</span><span>アクション</span></span>
    </a>
    <a id="card-reversi-link" class="side-menu__button" href="https://card.reversi-0.workers.dev/" target="_blank" rel="noopener noreferrer external" aria-label="カードリバーシ（別タブで開く）" title="別タブで開く">
      ${icon('cards')}<span class="side-menu__label side-menu__label--wrap"><span>カード</span><span>リバーシ</span></span>
    </a>
  </nav>`;
}
